import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

interface PassedProps {
    explanation?: string | JSX.Element;
    onKeyDown?: Function;
}

const CityComponent = ({
    value,
    isErrored,
    onChange,
    onKeyDown = undefined,
    placeholder = '',
}: FormFieldComponentProps & PassedProps) => {
    return (
        <div className="sid-field sid-city">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-city">
                <div className={`sid-field__label sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <div className="sid-field__label sid-field__label--required">
                        <FormattedHTMLMessage
                            id="city"
                            defaultMessage="City"
                        />
                    </div>
                </div>
            </label>
                <input
                    className={
                        `sid-text-input sid-text-input--required
                            sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                    }
                    id="sid-city"
                    name="sid-city"
                    type="city"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    onKeyDown={typeof onKeyDown === 'function' ? e => onKeyDown(e) : undefined}
                    placeholder={placeholder}
                    ref={input => setRef('city', input)}
                />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidCity"
                            defaultMessage="Invalid city"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { CityComponent };
